import { makeStyles } from '@material-ui/styles'
import React from 'react'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import deleteVmStyles from './deleteVmStyles'

const useStyles = makeStyles<Theme>((theme) => ({
  ...deleteVmStyles(theme),
}))

export default function DetailedDeleting({
  haveVolumeSnapshotsToDelete,
  volumesToDelete,
  portsToDelete,
}) {
  const classes = useStyles()
  return (
    <div className={classes.detailedContainer}>
      <Text variant="subtitle2">Deletion in progress...</Text>
      {haveVolumeSnapshotsToDelete && (
        <Text variant="body2">
          <b>NOTE:</b> VM deletion will take longer as dependent volume snapshots are cleaned up.
        </Text>
      )}
      <div className={classes.detailedDeleteBoxes}>
        <div className={classes.detailedDeleteBox}>
          <FontAwesomeIcon className={classes.simpleResultsSpinner} spin duotone>
            spinner-third
          </FontAwesomeIcon>
          <div>
            <Text variant="subtitle2">VMs</Text>
            <Text variant="body2">Deleting...</Text>
          </div>
        </div>
        {volumesToDelete?.length > 0 && (
          <div className={classes.detailedDeleteBox}>
            <FontAwesomeIcon className={classes.simpleResultsSpinner} spin duotone>
              spinner-third
            </FontAwesomeIcon>
            <div>
              <Text variant="subtitle2">Volumes</Text>
              <Text variant="body2">Deleting...</Text>
            </div>
          </div>
        )}
        {portsToDelete?.length > 0 && (
          <div className={classes.detailedDeleteBox}>
            <FontAwesomeIcon className={classes.simpleResultsSpinner} spin duotone>
              spinner-third
            </FontAwesomeIcon>
            <div>
              <Text variant="subtitle2">Ports</Text>
              <Text variant="body2">Deleting...</Text>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
